package com.sweetlime.bingeamigo.state

import com.sweetlime.bingeamigo.model.Movie

sealed class MovieState {
    data class Success(val movies: List<Movie>): MovieState()
    data class Error(val message: String): MovieState()
    data object Loading: MovieState()
    data object Idle: MovieState()
}